export type Point = { x: number; y: number };

export function pointerCoords(event: Point, last: Point): Point {
  if (event.x === 0 && event.y === 0) return last;
  return event;
}

export function once(fn: () => void): () => void {
  let done = false;
  return () => {
    if (done) return;
    done = true;
    fn();
  };
}
